import * as React from "react";

interface IProps {
    toggleHidden: React.ReactNode
    toggleShown: React.ReactNode
    togglePositionTop?: boolean
    className?: string
    isShown?:boolean
}

interface IState {
    isShown: boolean
}

export class FalconAccordion extends React.Component<React.PropsWithChildren<IProps>, IState> {

    constructor(props: React.PropsWithChildren<IProps>) {
        super(props);
        this.state = {
            isShown: this.props.isShown ?? false
        }
    }

    public render() {
        return (
            <div className={`falcon-accordion ${this.props.className}`}>
                {this.props.togglePositionTop ? this.renderIfTop() : this.renderIfBottom()}
            </div>
        );
    }

    private renderIfTop = (): React.ReactNode => {
        return (
            <>
                <div onClick={this.toggle} tabIndex={0} onKeyPress={this.toggle}>
                    {this.state.isShown ? this.props.toggleShown : this.props.toggleHidden}
                </div>
                {this.state.isShown && <div>{this.props.children}</div>}
            </>
        );
    };

    private renderIfBottom = (): React.ReactNode => {
        return (
            <>
                {this.state.isShown && <div>{this.props.children}</div>}
                <div onClick={this.toggle}>
                    {this.state.isShown ? this.props.toggleShown : this.props.toggleHidden}
                </div>
            </>
        );
    };

    private toggle = (): void => {
        this.setState({isShown: !this.state.isShown});
    };
}
